import React, { useState, useEffect } from "react";
const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL;

const ToggleZohoSync = ({ selectedCard, setIsSomethingChanged }) => {
  const [enabled, setEnabled] = useState(false);
  const [syncZohoData, setSyncZohoData] = useState(null);

  const handleToggle = () => {
    setEnabled((prev) => !prev);
  };

  useEffect(() => {
    const syncZoho = async () => {
      try {
        const response = await fetch(`${REACT_APP_SERVER_URL}/sync_to_books`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          method: "POST",
          body: JSON.stringify({
            crm_acc_id: selectedCard.crm_acc_id,
            work_id: selectedCard.id,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to sync with Zoho");
        } else {
          const data = await response.json();
          setSyncZohoData(data);
          setIsSomethingChanged((prev) => !prev);
        }
      } catch (error) {
        console.error("Error during Zoho sync:", error);
      }
    };

    // Call syncZoho only when enabling
    if (enabled) {
      syncZoho();
    }
    // eslint-disable-next-line
  }, [enabled, selectedCard]);

  const switchContainer = {
    position: "relative",
    display: "inline-block",
    width: "50px",
    height: "28px",
    verticalAlign: "middle",
  };

  const switchInput = {
    opacity: 0,
    width: 0,
    height: 0,
  };

  const slider = {
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: enabled ? "#3a7bd5" : "#ccc",
    transition: "0.4s",
    borderRadius: "28px",
  };

  const sliderBefore = {
    position: "absolute",
    content: "''",
    height: "20px",
    width: "20px",
    left: enabled ? "26px" : "4px",
    bottom: "4px",
    backgroundColor: "white",
    transition: "0.4s",
    borderRadius: "50%",
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Switch */}
      <label style={switchContainer}>
        <input
          type="checkbox"
          checked={enabled}
          onChange={handleToggle}
          style={switchInput}
        />
        <span style={slider}>
          <span style={sliderBefore}></span>
        </span>
      </label>
      <span style={{ marginLeft: "10px", fontSize: "16px" }}>
        Toggle Zoho Sync
      </span>

      {/* Toggle Result */}
      {syncZohoData && (
        <div
          style={{
            marginTop: "15px",
            padding: "10px",
            backgroundColor: "#f0f4ff",
            border: "1px solid #3a7bd5",
            borderRadius: "5px",
            display: "inline-block",
          }}
        >
          <strong>Sync to Zoho Book</strong>
        </div>
      )}
    </div>
  );
};

export default ToggleZohoSync;
